/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Password reset request
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * New password to set (if not provided, a random password will be generated)
     * @type {string}
     * @memberof PasswordResetRequest
     */
    newPassword?: string;
    /**
     * Whether the password should be temporary (force reset on next login)
     * @type {boolean}
     * @memberof PasswordResetRequest
     */
    temporaryPassword?: boolean;
    /**
     * Whether to send password reset email to the user
     * @type {boolean}
     * @memberof PasswordResetRequest
     */
    sendEmail?: boolean;
}

/**
 * Check if a given object implements the PasswordResetRequest interface.
 */
export function instanceOfPasswordResetRequest(value: object): value is PasswordResetRequest {
    return true;
}

export function PasswordResetRequestFromJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestFromJSONTyped(json, false);
}

export function PasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
        'temporaryPassword': json['temporaryPassword'] == null ? undefined : json['temporaryPassword'],
        'sendEmail': json['sendEmail'] == null ? undefined : json['sendEmail'],
    };
}

export function PasswordResetRequestToJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestToJSONTyped(json, false);
}

export function PasswordResetRequestToJSONTyped(value?: PasswordResetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newPassword': value['newPassword'],
        'temporaryPassword': value['temporaryPassword'],
        'sendEmail': value['sendEmail'],
    };
}

